{
  "meta": {
    "title": "Informații legale | Khromatik",
    "description": "Informații legale, confidențialitate și date despre Khromatik Digital S.R.L."
  },
  "heading": {
    "main": "Informații legale"
  },
  "legalBasis": "Informații privind prestatorul serviciului, în conformitate cu legislația aplicabilă.",
  "company": {
    "name": "KHROMATIK DIGITAL S.R.L.",
    "address": "Str. Armoniei, nr. 23A, ap. B1\nTimișoara, România",
    "regLabel": "Nr. Registrului Comerțului:",
    "regValue": "J2026019403001",
    "cuiLabel": "Cod unic de înregistrare (CUI):",
    "cuiValue": "54324200"
  },
  "contact": {
    "heading": "Contact:",
    "emailLabel": "E-mail:"
  },
  "privacy": {
    "title": "Politica de confidențialitate",
    "leadTitle": "Protecția datelor",
    "lead": "Tratăm protecția datelor dumneavoastră personale cu seriozitate. Prelucrăm datele personale în conformitate cu legislația privind protecția datelor și cu această politică.",
    "controllerTitle": "Operator (responsabil cu prelucrarea)",
    "controllerAddress": "KHROMATIK DIGITAL S.R.L.\nStr. Armoniei, nr. 23A, ap. B1\nTimișoara, România",
    "accessDataTitle": "Date de acces (jurnale server)",
    "accessDataIntro": "La vizitarea acestui site, furnizorul de găzduire poate înregistra automat informații tehnice despre acces (fișiere jurnal), inclusiv:",
    "accessDataList": {
      "i1": "Pagina accesată",
      "i2": "Data și ora accesului",
      "i3": "Volumul de date transferate",
      "i4": "Sursa / referința de la care ați ajuns pe pagină",
      "i5": "Tipul de browser",
      "i6": "Sistemul de operare",
      "i7": "Adresa IP (de obicei trunchiată sau anonimizată de gazdă)"
    },
    "accessDataOutro": "Aceste date sunt folosite pentru securitate, depanare și analize statistice. Ne rezervăm dreptul de a examina jurnalele dacă există indicii concrete de utilizare nelegitimă.",
    "cookiesTitle": "Cookie-uri",
    "cookiesP1": "Acest site folosește stocare în browser necesară din punct de vedere tehnic (de ex. localStorage) pentru limba aleasă și pentru consimțământul privind cookie-urile. Dacă sunteți de acord, Google Analytics și Microsoft Clarity pot folosi cookie-uri sau tehnologii similare. Puteți acorda sau retrage consimțământul prin banner la prima vizită sau oricând prin „Setări cookie” din subsol. Fără acord, aceste instrumente de analiză nu se încarcă.",
    "cookiesP2": "Conținut încorporat (de ex. videoclipuri Vimeo) poate plasa cookie-uri de la terți; nu le controlăm direct. Puteți restricționa sau șterge cookie-uri din setările browserului.",
    "rightsTitle": "Drepturile dumneavoastră",
    "rightsP1": "În măsura prevăzută de lege (inclusiv GDPR, dacă este aplicabil), puteți avea dreptul la informare, rectificare, ștergere, restricționarea prelucrării, opoziție și portabilitatea datelor.",
    "rightsP2": "Pentru întrebări privind protecția datelor, ne puteți contacta la datele de mai sus."
  },
  "disclaimer": {
    "title": "Limitări de răspundere",
    "contentTitle": "Răspunderea pentru conținut",
    "contentP1": "Întreținem conținutul acestor pagini cu atenție, fără a garanta că este mereu complet, actual sau fără erori. Răspundem pentru propriul conținut conform legii aplicabile; nu suntem obligați să monitorizăm informații terțe fără indicii concrete de ilegalitate.",
    "contentP2": "Obligațiile de a elimina sau bloca utilizarea ilegală a informațiilor rămân neschimbate. Răspunderea intervine după ce luăm cunoștință de o încălcare concretă. Vom înlătura conținutul relevant fără întârzieri nejustificate după notificare.",
    "linksTitle": "Răspunderea pentru linkuri",
    "linksP1": "Site-ul poate conține linkuri către site-uri externe. Nu influențăm conținutul acelor site-uri și nu ne asumăm răspundere pentru acesta. Furnizorul paginii respective este responsabil pentru conținutul acesteia.",
    "linksP2": "La momentul plasării linkurilor, am verificat absența unor încălcări evidente. Nu este rezonabil un control permanent fără indicii concrete. Vom elimina linkurile dacă aflăm despre încălcări."
  },
  "credits": {
    "title": "Credite imagini",
    "photosPrefix": "Fotografii de la",
    "iconsPrefix": "Pictograme de la"
  }
}
